import BigNumber from 'bignumber.js';
import Convert from 'convert-units';

export default class Quantity {

    /**
     * Crate a new instance of quantity
     * @param amount
     * @param name
     * @param symbol
     * @param base_unit
     * @param type
     */
    constructor({amount, unitName, unitSymbol}) {
        this.amount     = amount instanceof Quantity ? amount : new BigNumber(amount || 0);
        this.unitName   = unitName;
        this.unitSymbol = unitSymbol;

        this.format = {
            prefix: '',
            decimalSeparator: '.',
            groupSeparator: ',',
            groupSize: 3,
            secondaryGroupSize: 0,
            fractionGroupSeparator: ' ',
            fractionGroupSize: 0,
            suffix: this.unitSymbol
        };
    }

    /**
     * Convert amount form one unit to another
     * @returns {*}
     */
    convert(toUnit) {
        return new Quantity({
            amount: Convert(this.amount).from(this.unitSymbol).to(toUnit),
            unitName: Convert().describe(toUnit).singular,
            unitSymbol: toUnit

        });
    }

    /**
     * To be used in presentation
     */
    toString() {
        return this.amount.toFormat(this.format);
    }

    static getConversionRate(fromUnit, toUnit){
        return Convert(1).from(fromUnit).to(toUnit);
    }
}